import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { LessonBreadcrumbComponent } from './exercise/shared/lesson-breadcrumb/lesson-breadcrumb.component';

@Component({
    selector: 'app-lesson',
    templateUrl: './lesson.component.html',
    styleUrls: ['./lesson.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [RouterOutlet, LessonBreadcrumbComponent]
})
export class LessonComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
